import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Box, Link, Button } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import logo from './logo512.png';

const useStyles = makeStyles({
    headerH1: {
        color: 'blue',
        fontWeight: 'bold',
        '&:hover': {
            color: '#2f17ad',
            cursor: 'pointer',
        },
    },
});

export default function Header() {
    const classes = useStyles();
    return (
        <Grid item xs={12}>
            <Grid container direction='column' spacing={2}>
                <Grid item>
                    <Box display='flex' justifyContent='center'>
                        <Avatar
                            alt='DYL Editor'
                            src={`${process.env.PUBLIC_URL}/logo512.png`}
                        />
                    </Box>
                </Grid>
                <Grid item>
                    <Typography
                        onClick={() =>
                            window.open(
                                process.env.REACT_APP_CHROME_STORE,
                                '_blank'
                            )
                        }
                        align='center'
                        component='h1'
                        className={classes.headerH1}
                    >
                        DYL Editor
                    </Typography>
                </Grid>

                <Grid item>
                    <Box mt={1} display='flex' justifyContent='center'>
                        <Button
                            onClick={() =>
                                window.open(
                                    'https://dim0147.github.io/dyl-editor/en/update'
                                )
                            }
                            variant='contained'
                            color='secondary'
                        >
                            About Extension
                        </Button>
                    </Box>
                </Grid>
                <Grid item>
                    <Box display='flex' justifyContent='center'>
                        <Button
                            onClick={() =>
                                window.open(
                                    'https://dim0147.github.io/dyl-editor/privacy'
                                )
                            }
                            style={{ marginBottom: 10 }}
                            variant='contained'
                            color='primary'
                        >
                            Privacy 6 Policies
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    );
}
